"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Empty = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Text_1 = require("../Text");
function Empty({ testId, className, message, isBoxless }) {
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(!isBoxless && 'border border-borderColor bg-gray-600 rounded-lozenge', 'p-4', 'text-center', 'box-border', className), "data-testid": testId },
        react_1.default.createElement(Text_1.Text, { type: Text_1.TextType.BODY_S, subdued: true, className: "leading-none" }, message)));
}
exports.Empty = Empty;
//# sourceMappingURL=Empty.js.map